import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Public axios — no credentials, works cross-origin through ingress/CF edge
export const api = axios.create({ baseURL: API, timeout: 30000 });

// Authenticated axios — sends httpOnly cookies. Used only for auth + admin endpoints.
export const authApi = axios.create({
  baseURL: API,
  timeout: 30000,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}

// ---- Public content ----
export const fetchPosts = async (params = {}) => (await api.get("/posts", { params })).data.items || [];
export const fetchPost = async (slug) => (await api.get(`/posts/${slug}`)).data;
export const fetchRelated = async (slug, limit = 3) =>
  (await api.get(`/posts/${slug}/related`, { params: { limit } })).data.items || [];
export const fetchCategories = async () => (await api.get("/categories")).data.items || [];
export const fetchTags = async () => (await api.get("/tags")).data.items || [];

// ---- Newsletter / contact ----
export const subscribeNewsletter = async (email) => (await api.post("/newsletter/subscribe", { email })).data;
export const submitContact = async (payload) => (await api.post("/contact", payload)).data;

// ---- Auth (cookies) ----
export const authLogin = async (email, password) =>
  (await authApi.post("/auth/login", { email, password })).data;
export const authMe = async () => (await authApi.get("/auth/me")).data;
export const authLogout = async () => (await authApi.post("/auth/logout")).data;

// ---- Admin (cookies) ----
export const adminCreatePost = async (post) => (await authApi.post("/admin/posts", post)).data;
export const adminUpdatePost = async (slug, post) => (await authApi.put(`/admin/posts/${slug}`, post)).data;
export const adminDeletePost = async (slug) => (await authApi.delete(`/admin/posts/${slug}`)).data;
export const adminUpload = async (file, onProgress) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await authApi.post("/admin/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => onProgress?.(e),
  });
  return data;
};
export const adminListMedia = async (kind) =>
  (await authApi.get("/admin/media", { params: kind ? { kind } : {} })).data.items || [];
export const adminDeleteMedia = async (id) => (await authApi.delete(`/admin/media/${id}`)).data;

// ---- Affiliates (public list) ----
export const fetchAffiliates = async (category) =>
  (await api.get("/affiliates", { params: category ? { category } : {} })).data.items || [];
// Absolute redirect URL for affiliate clicks (handles tracking + redirect on backend)
export const affiliateGoUrl = (slug) => `${API}/go/${slug}`;

// ---- Admin Affiliates ----
export const adminListAffiliates = async () =>
  (await authApi.get("/admin/affiliates")).data.items || [];
export const adminCreateAffiliate = async (payload) =>
  (await authApi.post("/admin/affiliates", payload)).data;
export const adminUpdateAffiliate = async (slug, payload) =>
  (await authApi.put(`/admin/affiliates/${slug}`, payload)).data;
export const adminDeleteAffiliate = async (slug) =>
  (await authApi.delete(`/admin/affiliates/${slug}`)).data;
